export default [
  // {
  //   path: 'verifactu',
  //   name: 'verifactu',
  //   redirect: { name: 'verifactu' }
  // },
  {
    icon: 'bell',
    path: 'verifactu',
    name: 'verifactu',
    component: () => import('@/views/invoices/Verifactus.vue'),
    meta: { registerNavFromMenu: true, status: 99999 }
  },
  {
    path: 'verifactu/:type/:IdCliente/:IdCifEmpresa/:NumSerieFactura/:FechaExpedicion/details',
    name: 'verifactu/details',
    component: () => import('@/views/invoices/Verifactu.vue'),
    meta: { secondaryMenu: 'verifactu', registerNavFromMenu: false, recibida: true }
  },
  {
    path: 'verifactu/:type/:IdCliente/:IdCifEmpresa/:NumSerieFactura/:FechaExpedicion/historical',
    name: 'verifactu/historical',
    component: () => import('@/views/historical/VerifactuHistorical.vue'),
    meta: { secondaryMenu: 'verifactu', registerNavFromMenu: false, recibida: true }
  },
]
